// ======================================================
// custom-cart-count.js — Stable for Creative Theme
// ======================================================

const BADGE_SELECTOR = '.cart-count-bubble, #cart-icon-bubble, [data-cart-count]';

// ---- Fetch helpers (safe, debounced) ---- //
let inFlight = false;
async function fetchCart() {
  try {
    const res = await fetch('/cart.js', {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) {
      console.warn('Cart fetch failed:', res.status, res.statusText);
      return null;
    }
    return await res.json();
  } catch (err) {
    console.error('Fetch cart error:', err);
    return null;
  }
}

// ---- Counting rules ---- //
function computeCustomCount(cart) {
  let total = 0;
  cart.items.forEach(i => {
    const partOfSub = i.properties?.['Part of Subscription'] || i.properties?.part_of_subscription;
    const displayOnly = i.properties?.['DisplayOnly'] || i.properties?.displayonly;
    if (displayOnly === 'true') total += 1;            // subscription parent = 1
    else if (partOfSub !== 'true') total += i.quantity; // normal items by qty
  });
  return total;
}

// ---- Paint UI ---- //
function paintCartPage(total) {
  const countEl = document.querySelector('cart-quantity-info items-count');
  const labelEl = document.querySelector('cart-quantity-info info-content');
  if (!countEl || !labelEl) return;
  countEl.textContent = total;
  labelEl.textContent = total === 1 ? 'item' : 'items';
  const wrapper = countEl.closest('cart-quantity-info');
  if (wrapper) wrapper.toggleAttribute('hidden', total === 0);
}

function paintHeaderBadges(total) {
  document.querySelectorAll(BADGE_SELECTOR).forEach(bubble => {
    // Creative sometimes nests <items-count>; sometimes uses text directly
    const inner =
      bubble.querySelector('items-count') ||
      bubble.querySelector('[aria-hidden="true"]') ||
      bubble.firstElementChild;

    if (inner) inner.textContent = total > 0 ? String(total) : '';
    else bubble.textContent = total > 0 ? String(total) : '';

    bubble.setAttribute('data-cart-count', String(total));
    bubble.style.display = total > 0 ? '' : 'none';
    bubble.toggleAttribute('hidden', total === 0);
    bubble.classList.toggle('is-visible', total > 0);
  });
}

// If header mounts a bit later, repaint without refetching
let lastTotal = null;
function repaintLater() {
  if (lastTotal == null) return;
  setTimeout(() => paintHeaderBadges(lastTotal), 100);
  setTimeout(() => paintHeaderBadges(lastTotal), 400);
  setTimeout(() => paintHeaderBadges(lastTotal), 1200);
}

// ---- Core update (single-flight + debounce) ---- //
let debounceTimer = null;
async function updateCounts() {
  if (inFlight) return;
  inFlight = true;
  try {
    const cart = await fetchCart();
    if (!cart || !cart.items) return;
    lastTotal = computeCustomCount(cart);
    paintCartPage(lastTotal);
    paintHeaderBadges(lastTotal);
  } catch (e) {
    console.error('Cart count update failed:', e);
  } finally {
    inFlight = false;
  }
}

function debouncedUpdate() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(updateCounts, 350);
}

// ---- Listeners ---- //
function attachCartListeners() {
  document.querySelectorAll('quantity-input').forEach(qty => {
    qty.addEventListener('update', debouncedUpdate);
  });
}

function attachAddToCartListeners() {
  document.addEventListener('cart:updated', debouncedUpdate);
  document.addEventListener('cart:refresh', debouncedUpdate);
  document.addEventListener('ajaxProduct:added', debouncedUpdate);

  // Fallback for raw /cart/add.js calls
  (function (open) {
    XMLHttpRequest.prototype.open = function () {
      this._url = arguments[1];
      open.apply(this, arguments);
    };
  })(XMLHttpRequest.prototype.open);

  (function (send) {
    XMLHttpRequest.prototype.send = function () {
      const xhr = this;
      const prev = xhr.onreadystatechange;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr._url && xhr._url.includes('/cart/add')) {
          debouncedUpdate();
        }
        if (prev) prev.apply(xhr, arguments);
      };
      send.apply(xhr, arguments);
    };
  })(XMLHttpRequest.prototype.send);
}

// Repaint when Shopify dynamically loads header section
document.addEventListener('shopify:section:load', () => {
  paintHeaderBadges(lastTotal ?? 0);
});

// ---- Init ---- //
document.addEventListener('DOMContentLoaded', () => {
  updateCounts();           // initial fetch + paint
  repaintLater();           // covers late-mounted header
  attachCartListeners();    // cart page quantity changes
  attachAddToCartListeners();
});

// Support PJAX/Turbo-like navigation (if used by theme/apps)
document.addEventListener('page:load', updateCounts);


